import React, { createContext, useContext, useMemo } from 'react'
import { useTenant } from '@/hooks/Tenant'

const TenantContext = createContext(null)

export const TenantProvider = ({ children }) => {
  const { tenant, loadingTenant, getTenant } = useTenant()

  const value = useMemo(() => {
    return { tenant, loadingTenant, getTenant }
  }, [tenant, loadingTenant])

  return (
    <TenantContext.Provider value={value}>{children}</TenantContext.Provider>
  )
}

export const useTenantContext = () => {
  const ctx = useContext(TenantContext)
  if (!ctx) {
    throw new Error('useTenantContext must be used within a TenantProvider')
  }
  return ctx
}

export default TenantContext
